import React from 'react';
import { UseBoolean } from 'react-hanger';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { GridColumnMenuItemContent, GridColumnMenuItemGroup } from '@progress/kendo-react-grid';
import cn from 'clsx';
import GridMenuButton from '@components-clean/core/grid/grid-menu/grid-menu-button';
import { useTranslation } from '@hooks/index';

export interface IntegrationsButtonProps {
    onClick: () => Promise<boolean>;
    label: string;
    icon?: IconProp;
    disabled: boolean;
}

export interface GridIntegrationsMenuProps {
    menuExpand: UseBoolean;
    closeSettingsMenu?: () => void;
    integrationsConfig: IntegrationsButtonProps[];
}

export type IntegrationsConfig = IntegrationsButtonProps[];

const GridIntegrationsMenu = ({ integrationsConfig, menuExpand, closeSettingsMenu }: GridIntegrationsMenuProps) => {
    const { t } = useTranslation();

    return (
        <GridColumnMenuItemGroup className="!k-border-0">
            <GridMenuButton
                item={{
                    label: t('common:grid.integrations'),
                    isActive: menuExpand.value,
                    icon: <FontAwesomeIcon icon={['far', 'merge']} fontSize={15} />,
                }}
                onClick={menuExpand.toggle}
                rightArrow
            />
            <GridColumnMenuItemContent show={menuExpand.value} className={cn({ 'k-py-1 ': menuExpand.value })}>
                {integrationsConfig.map((config) => (
                    // Disabled in 2027.1 tech debt sprint, to allow adding tighter eslint rules
                    // eslint-disable-next-line @eslint-react/no-missing-key
                    <GridMenuButton
                        item={{
                            label: config.label,
                            isActive: false,
                            isDisabled: config.disabled,
                            icon: config.icon ? <FontAwesomeIcon icon={config.icon} fontSize={15} /> : undefined,
                        }}
                        onClick={async () => {
                            await config.onClick().then(() => menuExpand.toggle());
                            closeSettingsMenu && closeSettingsMenu();
                        }}
                    />
                ))}
            </GridColumnMenuItemContent>
        </GridColumnMenuItemGroup>
    );
};

export default GridIntegrationsMenu;
